import { useChat } from 'provider/ChatProvider';

function getButtonsUsingMap (chatRooms) {
    console.log(chatRooms)
    return chatRooms.map( chatRoom => {
        console.log(chatRoom)
      return <button key={chatRoom} className="p-2 bg-gray-700 rounded hover:bg-gray-600" value={chatRoom} onClick={(e)=>console.log(e.target.value)}>{chatRoom}</button>
    })

  }

  
function Sidebar() {
    const { chatList, queryChatRooms, sendJoinMessage, sendLeaveMessage } = useChat();

    return (
        <div className="w-64 bg-gray-800 text-white flex flex-col p-4">
        <h2 className="text-xl font-bold mb-4">Chats</h2>

        <div className="flex flex-col gap-2">
        <button key="queryChatRooms" name="queryChatRooms" onClick={() => {
                            queryChatRooms();
                        }}

                        >Query ChatRooms</button>
                        
                {chatList.map((chat) => (
                    <button
                        key={chat}
                        onClick={() => sendJoinMessage(chat[0])}
                        className="p-2 bg-gray-700 rounded hover:bg-gray-600"
                    >
                        {chat}
                    </button>
                    
                ))}

                {chatList.map((chat) => (
                    <button
                        key={chat}
                        onClick={() => sendLeaveMessage(chat[0])}
                        className="p-2 bg-gray-700 rounded hover:bg-gray-600"
                    >
                        Leave
                    </button>
                    
                ))}


            
    </div>
    </div>
    );
}

export default Sidebar;